// extracted by mini-css-extract-plugin
export default {"title":"_4ErS4SWI0EARAC6v2b8ViL"};